module.exports = __webpack_public_path__ + "img/create-package-icon.f6f884a4.svg";